/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_User_FallbackInputs */

const en_nav_app_user_fallback = /** @type {(inputs: Nav_App_User_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const es_nav_app_user_fallback = /** @type {(inputs: Nav_App_User_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Nav_App_User_FallbackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_user_fallback = /** @type {((inputs?: Nav_App_User_FallbackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_User_FallbackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_user_fallback(inputs)
	return en_nav_app_user_fallback(inputs)
});